import React from 'react';
import LoadingBar from 'react-redux-loading-bar';

const Loading = () => {
  return (
    <div className="loading">
      <LoadingBar />
    </div>
  );
};

export default Loading;
